var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"height":"100% !important"}},[_c('router-view',{staticClass:"main-router-view",staticStyle:{"height":"100% !important"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }